/* PATIENT_FEEDBACKS */
export const ADD_NEW_PATIENT_FEEDBACK = "ADD_NEW_PATIENT_FEEDBACK";
export const ADD_PATIENT_FEEDBACK_SUCCESS = "ADD_PATIENT_FEEDBACK_SUCCESS";
export const ADD_PATIENT_FEEDBACK_FAIL = "ADD_PATIENT_FEEDBACK_FAIL";
